import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent, { timelineOppositeContentClasses, } from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { devError } from '@zurich/common/utils';
import { NoSSR } from '../NoSSR';
export function ErrorTimeline({ error, errorViewHandler, createErrorObject, }) {
    const parents = error.getInstantiatedParents(createErrorObject);
    const errors = [error, ...parents];
    return (_jsx(Timeline, { sx: {
            [`& .${timelineOppositeContentClasses.root}`]: {
                flex: 0.2,
            },
        }, children: errors.map((error, index) => {
            const View = errorViewHandler(error);
            if (!View) {
                devError('Unhandled error view:', JSON.stringify(error));
                return null;
            }
            return (_jsxs(TimelineItem, { children: [_jsx(TimelineOppositeContent, { color: "text.secondary", children: _jsx(NoSSR, { children: error.timestamp.toLocaleTimeString() }) }), _jsxs(TimelineSeparator, { children: [_jsx(TimelineDot, {}), _jsx(TimelineConnector, {})] }), _jsx(TimelineContent, { children: _jsx(View, { index: parents.length - index + 1, error: error }) })] }, index));
        }) }));
}
